<template>
	<lcsj-dialog v-model="showDialog" title="修改库存商品数量" width="80%" @close="closeDialog" cancel-text="关闭" confirm-text="确认修改" :confirm-loading="isSubmitting" @confirm="handleConfirmEdit"><div class="item_info border_Green">
			<div class="item_title">
				<div class="title">商品信息</div>
				<div class="btnDiv"></div>
			</div>
			<el-table class="lcsj-data-table" :cell-class-name="$moneyCellClass"
				v-loading="loading"
				:data="transferProductDtlData"
				border
				stripe
				style="width: 100%; border-radius: 10px"
				:header-cell-style="{textAlign: 'center'}"
				:cell-style="{ textAlign: 'center' }"
			>
				<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
				<el-table-column prop="productInfo.typeName" label="类型名称" width="120"></el-table-column>
				<el-table-column prop="productInfo.productName" label="商品名称"></el-table-column>
				<el-table-column prop="productInfo.specification" label="规格"></el-table-column>
				<el-table-column prop="price" label="单价(元)" width="90"></el-table-column>
				<el-table-column prop="quantity" label="数量" width="160">
					<template #default="scope">
						<el-input-number v-model.number="scope.row.quantity" placeholder="请输入数量" size="small" :min="1" style="text-align: center" :step="1" width="80"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column prop="productInfo.unit" label="单位" width="60"></el-table-column>
			</el-table>
		</div>
		
	</lcsj-dialog>
</template>

<script>
import { GetStoreProductList, EditStoreProductQty } from "@/api/productApi.js";
export default {
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			showDialog: false,
			loading: false,
			editForm: {
				dtls: []
			},
			transferProductDtlData: [],
			transferProductKeyIdList: []
		};
	},
	// 注册组件
	components: {},
	created() {},
	computed: {},
	methods: {
		showEditQtyDialog(selectedRows) {
			this.showDialog = true;
			this.transferProductKeyIdList = selectedRows.map((item) => item.keyId);
			this.GetStoreProductList();
		},
		closeDialog() {
			this.showDialog = false;
			this.editForm = {
				dtls: []
			};
		},
		// 重置展示数据（打开弹窗/切换数据时清空旧内容）
		resetData() {
			this.transferProductDtlData = [];
		},
		// 获取商品信息列表
		GetStoreProductList() {
			this.resetData();
			this.loading = true;
			const paramer = {
				keyIds: this.transferProductKeyIdList
			};
			GetStoreProductList(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.transferProductDtlData = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取商品信息失败!");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 确认修改
		handleConfirmEdit() {
			this.loading = true;
			// 校验数量是否为空
			if (this.transferProductDtlData.some((item) => item.quantity == null)) {
				this.$message.error("请输入数量!");
				return;
			}
			// 校验数量是否为整数
			if (this.transferProductDtlData.some((item) => !Number.isInteger(item.quantity))) {
				this.$message.error("数量必须为整数!");
				return;
			}
			this.editForm.dtls = this.transferProductDtlData.map((item) => ({
				keyId: item.keyId,
				qty: item.quantity
			}));
			const paramer = {
				dtls: this.editForm.dtls
			};
			EditStoreProductQty(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.$message.success("修改成功!");
						this.closeDialog();
						this.$parent.getListData();
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("修改失败!");
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>

<style scoped>
.selectContent {
	margin-top: 20rpx;
	display: flex;
	justify-content: center;
	align-items: center;
}

.item_info {
	border-left: 5px solid var(--app-primary-hover);
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border-bottom: 2px solid var(--app-border);
}

.border_Green {
	border-left: 5px solid var(--app-success);
}
</style>
